import { Button, IconButton } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DataTablePagination from "../../components/Table/DataTablePagination.jsx";
import { getAllOrderedService } from "../../services/servicesServices.js";
import ServiceImage from "./additionFields/ServiceImage.jsx";
import ConstructionStatus from "./additionFields/ConstructionStatus.jsx";
import Contractor from "./additionFields/Contractor.jsx";
import Payment from "./additionFields/Payment.jsx";
import { convertDateToJalaali } from "../../utils/convertDate.js";
import { base_api_url } from "../../services/httpService.js";
import { DownloadRounded, QuestionAnswer } from "@mui/icons-material";
import { fileDownloaderWithName, fileDownloaderWithoutFormat } from "../../utils/fileDownloader.js";
import ReceiveService from "./additionFields/ReceiveService.jsx";
import ManagerDetail from "./additionFields/ManagerDetail.jsx";

const options = [
  {
    text: "همه سرویس‌ها",
    value: "",
  },
  {
    text: "سرویس‌های جاری",
    value: "o",
  },
  {
    text: "سرویس‌های تایید شده",
    value: "a",
  },
  {
    text: "سرویس‌های رد شده",
    value: "r",
  },
  {
    text: "سرویس‌های منقضی",
    value: "e",
  },
  {
    text: "در حال تحلیل",
    value: "an",
  },
  {
    text: "در انتظار تایید پارامتر ها",
    value: "wp",
  },
  {
    text: "در انتظار تایید کارشناس",
    value: "op",
  },
];

const OrderedServicePage = () => {
  const [forceRequest, setForceRequest] = useState(0);

  const navigate = useNavigate();

  const servicesCols = [
    {
      field: "code",
      text: "کد سرویس",
    },
    {
      field: null,
      text: "تصویر",
      element: (rowData) => (
        <ServiceImage rowData={rowData} scrollQuery="#div-content" />
      ),
    },
    {
      field: null,
      text: "وضعیت",
      element: (rowData) => <ConstructionStatus rowData={rowData} />,
    },
    {
      field: null,
      text: "پیمانکار",
      element: (rowData) => <Contractor rowData={rowData} />,
    },
    {
      field: null,
      text: "فاز فعلی",
      element: (rowData) => rowData.current_phase ? <span>{rowData.current_phase.title}</span> : <span>مشخص نشده</span>,
    },
    {
      field: null,
      text: "مبلغ (تومان)",
      element: (rowData) => <Payment rowData={rowData} access={"contractor"} />,
    },
    {
      field: null,
      text: "تاریخ تحویل",
      element: (rowData) => <span>{convertDateToJalaali(rowData.preparation_date)}</span>,
    },
    {
      field: null,
      text: "جزییات",
      element: (rowData) => {
        return (
          <Button
            variant="contained"
            onClick={() =>
              window.open(
                `http://app.wisercam.com/DetailOrder/${rowData.code}`
              )
            }
          >
            مشاهده
          </Button>
        );
      },
    },
    {
      field: null,
      text: "فایل مشتری",
      element: (rowData) => {
        return (
            <Button
                variant="contained"
                onClick={() => 
                    {
                        fileDownloaderWithName(`${base_api_url}/shop_admin/get_customer_file/${rowData.code}/`, null, false);
                    }}
            >
                <span className="ms-1">
                    <DownloadRounded />
                </span>
            </Button>
        );
      },
    },
    {
      field: null,
      text: "فایل نقشه",
      element: (rowData) => {
        return (
            <Button
                variant="contained"
                onClick={() => 
                    {
                        fileDownloaderWithoutFormat(`${base_api_url}/shop_admin/get_local_customer_file/${rowData.code}/`)
                    }}
            >
                <span className="ms-1">
                    <DownloadRounded />
                </span>
            </Button>
        );
      },
    },
    {
      field: null,
      text: "توضیحات",
      element: (rowData) =>  <ManagerDetail rowData={rowData} iO={"c"} />
    },
    {
      field: null,
      text: "درخواست پذیرش قطعه",
      element: (rowData) => <ReceiveService rowData={rowData} />,
    },
  ];

  return (
    <DataTablePagination
      tableCols={servicesCols}
      title={"پذیرش قطعات"}
      APIFunction={getAllOrderedService}
      dataField={"services"}
      hasOutlet={true}
      forceRequest={forceRequest}
      setForceRequest={setForceRequest}
    ></DataTablePagination>
  );
};

export default OrderedServicePage;
